import {isHeicFile} from '@/utils/isHeicFile';

export async function convertHeicToJpeg(file: File): Promise<Blob> {
  if (!isHeicFile(file)) {
    throw new Error('Not a HEIC File');
  }

  const heicTo = (await import('heic-to')).heicTo;

  const converted = await heicTo({
    blob: file,
    type: 'image/jpeg',
    quality: 0.5,
  });

  return Array.isArray(converted) ? converted[0] : converted;
}
